module.exports = __webpack_public_path__ + "img/attachment.b09d34b0.svg";